// extracted by mini-css-extract-plugin
export default {"text_container":"GameMode_text_container__Ei6Aj","back_btn":"GameMode_back_btn__mV4bd","back_icon":"GameMode_back_icon__PSsYi","text":"GameMode_text__IPYLn"};